import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ProtectedPage } from '~/src/components/templates'
import {
  ContainerOrderItem,
  ProductionInstructionContentCard,
  InstructionOptions,
  PlanIncludedParts,
  ExtraParts,
} from '~/src/components/organisms'

import { data } from './mockData'

const DataItemDetailMock = {
  images: [
    'https://imgd.aeplcdn.com/0x0/n/cw/ec/56265/f-pace-exterior-right-front-three-quarter-2.jpeg',
    'https://imgd.aeplcdn.com/0x0/n/cw/ec/56265/f-pace-exterior-right-front-three-quarter-2.jpeg',
    'https://imgd.aeplcdn.com/0x0/n/cw/ec/56265/f-pace-exterior-right-front-three-quarter-2.jpeg',
    'https://imgd.aeplcdn.com/0x0/n/cw/ec/56265/f-pace-exterior-right-front-three-quarter-2.jpeg',
    'https://imgd.aeplcdn.com/0x0/n/cw/ec/56265/f-pace-exterior-right-front-three-quarter-2.jpeg',
  ],
  name: 'TOYOTA PROBOX VAN PROBOX DBE-NCP160V 3L 2010',
  maker: 'TOYOTA',
  carName: 'PROBOX',
  modelCode: 'DBE-NCP160V',
  price: 30000,
}

/**
 * ContainerOrderInstruction
 * @returns
 */
export const ContainerOrderInstruction: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <ProtectedPage pageTitle={t('container_order_detail.container_order_details')}>
      <Box width={'100%'} marginBottom={3}>
        <ContainerOrderItem data={DataItemDetailMock} />
      </Box>

      <Box width={'100%'} marginBottom={3}>
        <InstructionOptions />
      </Box>
      <Box width={'100%'} marginBottom={3}>
        <ProductionInstructionContentCard>
          <PlanIncludedParts planParts={data.items.planParts} />
          <ExtraParts extraParts={data.items.extraParts} />
        </ProductionInstructionContentCard>
      </Box>
    </ProtectedPage>
  )
}
